import { Nut } from 'lucide-react';
import ValueTile from '../../../../component/common/Dashboard_widgets/valueTile';
import Icons from '../../../../component/svgs/icons';
import NutritionMeals from './NutritionMeals';
import { getRecipeeOverview } from '../../../../api/healthAPI';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Nutrition({ searchKey }) {
  const [Overview, setOverview] = useState({});
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const createRef = useRef(null);

  useEffect(() => {
    fetchOverview();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (createRef.current && !createRef.current.contains(e.target)) {
        setIsCreateOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const fetchOverview = async () => {
    try {
      const response = await getRecipeeOverview();
      setOverview(response.data);
      console.log('Workout Overview:', response);
    } catch (error) {
      console.error('Error fetching workout overview:', error);
    }
  };
  return (
    <>
      <div className="flex justify-end mb-2">
        <div ref={createRef} className="relative inline-block text-left">
          <button
            type="button"
            onClick={() => setIsCreateOpen(!isCreateOpen)}
            className="btn-primary"
          >
            Create New
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668" stroke="#F3F4F6" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          {isCreateOpen && (
            <div className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white dark:bg-shoorah-darkBgColor shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="py-1">
                <Link
                  to="/health/recipe/new"
                  className="block px-4 py-2 text-sm text-gray-700 dark:text-white hover:bg-gray-100 dark:hover:bg-shoorah-darkBgTabColor"
                  onClick={() => setIsCreateOpen(false)}
                >
                  New Meal
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
        <ValueTile icon={<Icons.activeIcon />} title="Total Meals" value={Overview.totalRecipee} />
        <ValueTile
          icon={<Icons.activeIcon />}
          title="Top Meal"
          value={Overview.topRecipe?.recipe_name || 'N/A'}
        />
        <ValueTile
          icon={<Icons.activeIcon />}
          title="Active Meals"
          value={Overview.activeRecipee}
        />
      </div>
      <NutritionMeals searchKey={searchKey} />
    </>
  );
}
